/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerListItemViewModelPaginatedResponse } from "../types/BannerListItemViewModelPaginatedResponse.ts";
import { bannerListItemViewModelSchema } from "./bannerListItemViewModelSchema.ts";

export const bannerListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => bannerListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<BannerListItemViewModelPaginatedResponse>;
